<template>
    <grid-loader :loading="isLoading" :color="spinnerColor" class="middle_abs"></grid-loader>
    <button class="returnBtn" @click="back">返回</button>
    <div  class="mt-2 container font" v-if="!isLoading">        
        <div class="topTitle d-flex justify-content-center">VIP会员</div>
        <div class="row">
        <div class="col-auto flex-fill" v-if="products!=undefined">
          
            <div class=" row">
          <div :class="selectedProduct==index?'col m-1 card selectedBox p-1 pl-2 pr-2': 'col m-1 card bg p-1'" v-for="(product,index) in products" :key="index">
            <div class=" d-flex justify-content-center align-items-center flex-column hand" @click="select(index)">
                <div :class=" selectedProduct==index?'selectedTitle':'title'">
                    {{ product.name }}
                </div>
                <div class="mt-2">
                    <span class="unit">￥</span><span class="price">{{ product.price }}</span>
                </div>
               
            </div>
  
            
  
            <!-- <div class="row mt-1">
              <div class='col  d-flex justify-content-start'>
                <router-link :to="`/qr/${account.objectId}`"> <img class="operationIcon" src="../assets/icon-login.svg" alt="登录" title="登录">登录</router-link>
              </div>
               <div class="col-auto  d-flex justify-content-center">
                <router-link :to="`/index/user/task/${account.objectId}`"><img class="operationIcon" src="../assets/icon-setting.svg" alt="账号管理" title="账号管理">账号管理</router-link>
               </div>
               <div class="col-auto d-flex justify-content-end">
                <router-link :to="`/index/user/note/${account.objectId}`"><img class="operationIcon" src="../assets/icon-file.svg" alt="笔记管理" title="笔记管理">笔记管理</router-link>
               </div>
              </div> -->
          
  
          </div>

        </div>
        <div class="row m-1 d-flex flex-column">
            <div class="title">
                会员权益
            </div>
            <div class="mt-1">
                <div class="card mt-1 p-1 title">AI生成笔记</div>
                <div class="card mt-1 p-1 title">每天更新两篇笔记（日更）</div>
                <div class="card p-1 mt-1 title">自有知识库</div>
                <div class="card p-1 mt-1 title">笔记审核</div>
                <div class="card p-1 mt-1 title">笔记修改</div>
                <div class="card p-1 mt-1 title">运营专家群内答疑</div>

            </div>
        </div>
  
        </div>
        <div class="col-auto ml-3 mt-1 d-flex align-items-center flex-column">
           <div class="">
            <span class="title">支付</span><span class="selectedTitle unit">￥</span><span class="price selectedTitle" v-if="products!=undefined && products.length>0">{{ products[selectedProduct].price }}</span>
           </div>
            <div class="mt-1">
                <qrcode-vue :value="qr_url" level="H" render-as="svg" v-if="qr_url!=undefined"/>
                <grid-loader v-else :color="spinnerColor"></grid-loader>
            </div>
            <div class="text-secondary mt-1">请用微信扫码支付</div>
         </div>
    </div>


        <div>
   
  
    </div> 
  
         
      </div>
  
  
  </template>
  
  <script>
  
  import GridLoader from 'vue-spinner/src/GridLoader.vue'
  import axios from 'axios';
  import QrcodeVue from 'qrcode.vue'
  
  export default {
    data(){
      
      return {
        accountId:null,
        products:[],
        isLoading:false,
        selectedProduct:0,
        spinnerColor:"#262626",
        qr_url:null,
        out_trade_id:null,
        stopCheck:false,
        axiosSource: axios.CancelToken.source()
      }
      
    },
    computed: {
       
    },

    created() {
    // 在父组件中设置标识
    var current = this.$route.path;
        console.log(current)
        console.log('fresh')
        sessionStorage.setItem('isRefreshed', 'true'); 
    },
    components: {
      GridLoader,
      QrcodeVue
    },
     setup(){
      
       var token=localStorage.getItem('sessionToken')
       axios.defaults.headers.common['X-Parse-Session-Token'] = token
  
    },
  

    unmounted(){
       
        this.stopCheck=true;
        console.log('unmouted...')
    },

    beforeUnmount(){
      console.log('cancel axios')
      this.stopCheck=true;
      this.axiosSource.cancel('Operation canceled by the user.'); // 在beforeDestroy钩子中使用取消令牌源取消请求
     },
  
    mounted(){
        console.log('mouted...')
        console.log(this.stopCheck)
      var token=localStorage.getItem('sessionToken');
      this.role=localStorage.getItem('role');
  
       if(token==undefined || token==null ||token=='')
       {
          this.$router.push('index')
          return
       }
       this.accountId = this.$route.params.id;

      this.getProducts();
    },
    methods:{
    
  
        back(){
      
      this.stopCheck=true;
      
        this.$router.go(-1)
      },
  
      select(index){
        this.selectedProduct=index;
    },
       async getProducts(){
        try{
            this.stopCheck=true;
            this.isLoading=true;
          const response = await axios.get(this.domain+'xhs/get_products',{ 
                  cancelToken: this.axiosSource.token // 在axios请求中使用取消令牌
            });
  
          var data=response.data
          if(data.status=='Suc')
          {
              var results=data.products
              this.products=results;

              this.getQr()
             
          }
          else
          {
              console.error(data)
              
          }
        }
        catch(error)
        {
            if (axios.isCancel(error)) {
          console.log('Request canceled', error.message);
              } 
              else
              {
                console.error(data)
              }
            
        }
        finally{
            this.isLoading=false;
        }
       
       
      },


      async checkPaid(){
        try{
            console.log('check....')
            console.log(this.stopCheck)
            if(this.stopCheck)
            {
                return
            }
          const response = await axios.get(this.domain+'xhs/queryorder?out_order_id='+this.out_trade_id+'&amount='+this.products[this.selectedProduct].price
          ,{ 
                  cancelToken: this.axiosSource.token // 在axios请求中使用取消令牌
            });
  
          var data=response.data
          const status = data['status'];
          console.log(data)
            if(status == 'SUCCESS')
            {
                this.$router.push('/index/user/paid/'+this.out_trade_id)
            }
            else if(status=='NOTPAY'){
                this.checkPaid()
            }
         
        }
        catch(error)
        {
            if (axios.isCancel(error)) {
          console.log('Request canceled', error.message);
              } 
              else
              {
                console.error(data)
              }
            
        }
      
       
       
      },

      
      async getQr(){
        try{
            
            this.stopCheck=true;
            this.isLoading=true;
            
           var selected_product= this.products[this.selectedProduct]
           var parse_data={
            'account_id':this.accountId,
            'product_id':selected_product.objectId,
            
            cancelToken: this.axiosSource.token
            
           }
          const response = await axios.post(this.domain+'xhs/wechatpay',parse_data);
  
          var data=response.data
          if(data.status=='Suc')
          {
              this.qr_url=data.code_url
              this.out_trade_id=data.out_trade_no
              this.stopCheck=false;

            console.log('checking flag')
              console.log(this.stopCheck)
             this.checkPaid()
          }
          else
          {
              console.error(data)
              
          }
        }
        catch(error)
        {
            if (axios.isCancel(error)) {
          console.log('Request canceled', error.message);
              } 
              else
              {
                console.error(data)
              }
        }
        finally{
            this.isLoading=false;
        }
       
       
      },
  
    }
     
    
  };
  </script>
  <style scoped>
  .bg{
    background-color:#F9F9F9;
    border: 0;
  }
  .selectedBox{
    background-color: #f18f14;
    color:#4a2e2a;
  }
  
  .title{
    color:#666666;
    font-weight: 800;
    font-size: 0.25rem;
  }
  .selectedTitle{
    color:#4a2e2a;
    font-weight: 800;
    font-size: 0.25rem;
  }
  .price{
    font-size: 0.4rem;
    font-weight: 700;
  }
  .unit{
    font-size: 0.3rem;
    font-weight: 500;
  }
  
  .error-message{
    color:red
  }
  </style>
  
  
  